import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const csatEmployersCrudActionTypes = generateEntityCrudActionTypes('csatEmployers')

export default { ...csatEmployersCrudActionTypes }
